module.exports = __webpack_public_path__ + "img/wordpress.7f38cfa.svg";